<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>业务员账号列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入家长名称"
            v-model="queryInfo.query"
            clearable
            @clear="getUserList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getUserList"
            ></el-button>
          </el-input>
        </el-col>

        <el-col :span="6">
          <el-input
            placeholder="请输入卡号"
            v-model="queryInfo.cardId"
            clearable
            @clear="getUserList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getUserList"
            ></el-button>
          </el-input>
        </el-col>

        <!-- <el-col :span="6" v-if="canLook == 1">
          <el-button type="primary" size="mini" @click="addDialogVisible = true">添加经销商</el-button>
          <el-button type="primary" size="mini" @click="mutableSetSalesman">批量修改业务员</el-button>
        </el-col> -->
        <!-- <el-col :span="2" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col> -->
      </el-row>
      <el-table :data="userlist" border stripe>
        <!-- <el-table-column fixed type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index"></el-table-column>

        <el-table-column
          label="卡号"
          prop="cardId"
          width="100px"
        ></el-table-column>
        
        <el-table-column label="用户信息" width="150px">
          <template slot-scope="scope">
            <div>家长：{{ scope.row.name }}</div>
            <div>学生：{{ scope.row.s_name }}</div>
            <div>电话：{{ scope.row.phone }}</div>
          </template>
        </el-table-column>

        <el-table-column label="VIP信息" prop="grade" width="180px">
          <template slot-scope="scope">
            <div>vip类型：{{ scope.row.c_title }}</div>
            <div>剩余次数：{{ scope.row.count }}</div>
            <div>购卡价格：{{ scope.row.price }}</div>
          </template>
        </el-table-column>

        <el-table-column label="时间节点" prop="grade" width="200px">
          <template slot-scope="scope">
            <div>发卡时间：{{ scope.row.vipBuyDate }}</div>
            <div>激活开始：{{ scope.row.vipActivateStartDate }}</div>
            <div>激活截止：{{ scope.row.vipActivateEndDate }}</div>
            <div>开始使用：{{ scope.row.vipStartDate }}</div>
            <div>结束使用：{{ scope.row.vipEndDate }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="备注"
          prop="beizhu"
          width="140px"
        ></el-table-column>

        <el-table-column
          label="操作员"
          prop="mPhone"
          width="100px"
        ></el-table-column>

        <!-- <template slot-scope="scope">
            
            <el-tag class="success" v-if="scope.row.status == '1'"
              >增加</el-tag > 
          </template> -->

        <el-table-column label="状态" width="90px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == 0"
              >待激活</el-tag >
              <el-tag class="primary" v-if="scope.row.status == 1"
              >已激活</el-tag > 
              <el-tag class="info" v-if="scope.row.status == 2"
              >已过期</el-tag > 
              <el-tag class="info" v-if="scope.row.status == 3"
              >已取消</el-tag >  
          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <!-- <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="editVip(scope.row.id)"
              >编辑</el-button 
            > -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="cancelVip(scope.row.id)"
              v-if="scope.row.status != 3"
              >取消会员</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog
      title="取消理由"
      :visible.sync="refuseDialogVisible"
      width="50%"
      @close="refuseDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="refuseForm"
        :rules="refuseFormRules"
        ref="refuseFormRef"
        label-width="130px"
      >
        <el-form-item label="理由" prop="refuseTip">
          <el-input v-model="refuseForm.refuseTip"></el-input>
        </el-form-item>
      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="refuseDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="postRefuse">确认</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
export default {
  data() {
    return {
      canLook: 1,
      // 图片上传组件的headers请求头对象
      headerObj: {
        Authorization: window.sessionStorage.getItem("token"),
      },

      // 获取用户列表的参数对象
      queryInfo: {
        query: "",
        cardId: "",
        pagenum: 1,
        pagesize: 10,
      }, 
      userlist: [],
      total: 0, 
      refuseDialogVisible: false, 
      refuseForm: {
        id: null,
        status: 3,
        refuseTip: "",
      }, 
      // 添加表单的验证规则对象
      refuseFormRules: {
        refuseTip: [{ required: true, message: "请输入理由", trigger: "blur" }],
      },
    };
  },

  created() {
    this.getUserList();
  },

  methods: {
    async getUserList() {
      if (window.sessionStorage.getItem("pathCanLook") == 2) {
        //仅查看
        this.canLook = 2;
      }
      const { data: res } = await this.$http.get(
        "admin/users/getUserOpenVipList",
        {
          params: this.queryInfo,
        }
      );
      if (res.code !== 200) {
        return this.$message.error("暂无用户vip列表！");
      }
      this.userlist = res.result.list;
      this.total = res.result.count;
      console.log(res);
    },

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getUserList();
    },

    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getUserList();
    },

    cancelVip(id) {
      this.refuseForm.id = id;
      this.refuseDialogVisible = true;
    },

    // 监听添加用户对话框的关闭事件
    refuseDialogClosed() {
      this.refuseDialogVisible = false;
      this.$refs.refuseFormRef.resetFields();
    },

    // 拒绝
    postRefuse() {
      this.$refs.refuseFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.post(
          "admin/userVipLog/cancelVip",
          this.refuseForm
        );
        if (res.code !== 200) {
          this.$message.error(res.message);
          return;
        }
        this.$message.success(res.message);
        this.refuseDialogVisible = false;
        this.getUserList();
      });
    },

    // 通过
    async postPass(id) {
      // 可以发起添加用户的网络请求
      const { data: res } = await this.$http.post(
        "admin/users/updateSalesmanStatus",
        {
          id: id,
          status: 1,
          refuseTip: "",
        }
      );
      if (res.code !== 200) {
        this.$message.error(res.message);
        return;
      }
      this.$message.success(res.message);
      this.getUserList();
    },
  },
};
</script>

<style lang="less" scoped>
.aaaa {
  margin-left: 10px;
}
.primary{
  background-color: rgba(64, 255, 0, 0.806);
}
</style>
